import Immutable from 'immutable';
import {
  CLEAR_BAGGAGE_ITEMS,
  FLAG_GETTING_BAGGAGE_ITEMS,
  GET_BAGGAGE_ITEMS,
  FLAG_ITEM_ACTIVITY,
  GET_BAGGAGE_ITEM,
  CLEAR_BAGGAGE_ITEM,
} from '../../../actions/types/baggage/Item';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  content: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BAGGAGE_ITEMS:
      return state.setIn(['content', 'loading'], payload);
    case GET_BAGGAGE_ITEMS:
      return state.setIn(['content', 'content'], Immutable.Map(payload));
    case CLEAR_BAGGAGE_ITEMS:
      return state.setIn(
        ['content', 'content'],
        INITIAL_STATE.getIn(['content', 'content']),
      );
    case FLAG_ITEM_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_BAGGAGE_ITEM:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_BAGGAGE_ITEM:
      return state.setIn(['current', 'content'], Immutable.Map());
    default:
      return state;
  }
};
